import type { SubmitPurchasePaymentData } from '@lingoda/api';
import { createAction, makeActionTrackable } from '@lingoda/core';
import type { PaymentOptions } from '../models';

export default makeActionTrackable(
    createAction<SubmitPurchasePaymentData & PaymentOptions>('purchases/PAY_PURCHASE'),
);
